/**
 * O AVISO DA APLICAÇÃO (0088): a peça da lista técnica ou da O.S. que não tem
 * aplicação validada para a máquina. É aviso, nunca bloqueio — a peça entra,
 * e o selo diz que ninguém conferiu que ela serve ali.
 *
 * Selo preenchido em âmbar (p.24): tinta de fundo, ponto na cor 500 e o texto
 * escrito, nunca só a cor. O mesmo na mesa e no celular.
 */
export function SeloSemAplicacao() {
  return (
    /* A frase inteira, sempre: no celular ela quebra em duas linhas em vez de
       virar "Sem aplicação validada…" — o aviso cortado não avisa. */
    <span className="inline-flex min-h-[var(--selo-altura)] max-w-full items-center gap-1.5 rounded-pill bg-atencao-fundo px-2.5 py-1 text-atencao-texto">
      <span aria-hidden="true" className="size-[var(--selo-ponto)] shrink-0 rounded-pill bg-atencao" />
      <span className="txt-selo leading-tight">Sem aplicação validada para esta máquina</span>
    </span>
  );
}
